import Vue from 'vue';
import Vuex from 'vuex';

import user from './modules/user';
import monitor from './modules/monitor';
import incident from './modules/incident';
import team from './modules/team';
import feature from './modules/feature';
import check from './modules/check';
import availability from './modules/availability';
import latency from './modules/latency';
import location from './modules/location';
import channel from './modules/channel';
import alertRule from './modules/alertRule';
import groups from './modules/groups';
import users from './modules/users';
import ui from './modules/ui';
// import changelog from './modules/changelog';

/**
* @link https://medium.com/@lachlanmiller_52885/a-pattern-to-handle-ajax-requests-in-vuex-2d69bc2f8984
* @link https://gist.github.com/lmiller1990/a4e9208a01707ff7c0e8447250fc6f13
* @link https://blog.sqreen.io/authentication-best-practices-vue/
* @link https://developers.google.com/web/progressive-web-apps/checklist
*
* When mutating, follow Vue's Reactivity Rules
* @link https://vuex.vuejs.org/guide/mutations.html#mutations-follow-vue-s-reactivity-rules
*/

Vue.use(Vuex);

export default new Vuex.Store({
    strict: process.env.NODE_ENV !== 'production',
    modules: {
        // Normalized stores
        user,
        team,
        feature,
        monitor,
        incident,
        check,
        availability,
        latency,
        location,
        channel,
        alertRule,
        // Other stores
        ui,
        groups,
        users,
        // changelog,
    },
});
